module.exports = __webpack_public_path__ + "img/token-icon.c4d0aa8e.png";